import React, { Component, useEffect, useState } from 'react'
import moment from 'moment'
import { isThisSecond } from 'date-fns/esm';
import sort_icon from "../../../images/general/arrow_2.svg";
import sort_icon_up from "../../../images/general/arrow_1.svg";
import { updateInvoiceOrder, updateIsPaymentReceivedOrder } from '../../../actions/updateOrderPaymentActions'
import { useDispatch, useSelector, connect } from 'react-redux'
import * as actions from "../../../actions/actions";
import { withRouter } from 'react-router-dom';
import Loader from "../../../components/LoaderNew/Loader"
import _ from 'lodash'

class ReportsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_array: this.props.reportsPageData.dataArray,
            sorted_tab: "client_name",
            //for sort  type - start
            sort_type_client: false,
            // sort_type_departments: false,
            sort_type_process: false,
            planned_value: false,
            actual_value: false,
            dataForCsv: [],
            total_actual: props.reportsPageData.total_actual
        }
    }

    sortDate = (sort_by) => {
        const { data_array, sort_type_client, sort_type_process, planned_value, actual_value } = this.state
        let copy_data = JSON.parse(JSON.stringify(data_array));
        let sort_data

        if (sort_by === "customer_name") {
            if (sort_type_client) {
                sort_data = copy_data.sort((a, b) => a[sort_by] && a[sort_by].localeCompare(b[sort_by]))
            } else {
                sort_data = copy_data.sort((a, b) => a[sort_by] && a[sort_by].localeCompare(b[sort_by])).reverse();
            }

            this.setState({
                sort_type_client: !sort_type_client
            })

        }
        else if (sort_by === "process") {
            if (sort_type_process) {
                sort_data = copy_data.sort((a, b) => a[sort_by].localeCompare(b[sort_by]))
            } else {
                sort_data = copy_data.sort((a, b) => a[sort_by].localeCompare(b[sort_by])).reverse();
            }

            this.setState({
                sort_type_process: !sort_type_process
            })

        } else if (sort_by === "planned") {
            if (planned_value) {
                sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by])
            } else {
                sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by]).reverse()
            }
            this.setState({
                planned_value: !this.state['planned_value']
            })
        } else if (sort_by === "actual") {
            if (actual_value) {
                sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by])
            } else {
                sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by]).reverse()
            }
            this.setState({
                actual_value: !this.state['actual_value']
            })
        }

        this.setState({
            data_array: sort_data,
            sorted_tab: sort_by
        }, () => {

            //update data array for csv
            this.props.updateDataArray(sort_data)
        })
    }

    updateDataForCsv = (idx, item, changes) => {
        let dataArray = [...this.state.data_array]
        dataArray[idx] = { ...item, ...changes }
        // this.props.updateDataArray(dataArray)
        this.setState({ data_array: dataArray }, () => this.props.updateDataArray(dataArray))
        // dataForCsv[idx] = {...item, ...changes}
    }

    componentDidUpdate(prevProps) {
        const { reportsPageData, updateStagesInFinancialReport, updateTotalActualValue } = this.props;

        // 1. Update data_array
        if (reportsPageData?.dataArray && !_.isEqual(prevProps?.reportsPageData?.dataArray, reportsPageData.dataArray)) {
            this.setState({ data_array: reportsPageData.dataArray });
        }

        // 2. Update total_actual
        if (reportsPageData?.total_actual !== prevProps?.reportsPageData?.total_actual) {
            this.setState({ total_actual: reportsPageData.total_actual });
        }

        // 3. Update total_actual based on invoice
        const prevInvoice = prevProps?.updateStagesInFinancialReport?.updateStageInvoice;
        const currInvoice = updateStagesInFinancialReport?.updateStageInvoice;

        if (currInvoice && prevInvoice !== currInvoice) {
            const delta = currInvoice.invoice_issued ? currInvoice.value : -currInvoice.value;
            this.setState(prevState => ({
                total_actual: prevState.total_actual + delta
            }), () => updateTotalActualValue(this.state.total_actual));
        }
    }


    render() {
        const { startingDate, endingDate, reportsPageData, isGenerated, isViewOnlyAccess, canCheckUnCheck } = this.props
        const { data_array, sorted_tab, sort_type_client, sort_type_departments, sort_type_process, planned_value, actual_value, total_actual } = this.state
        return (
            <div className="reports-page__reports">
                <header>
                    <h1>דו”ח פיננסי לחודש</h1>
                    <h2>
                        <span>{typeof endingDate === "string" ? endingDate : moment(endingDate).format('DD/MM/YYYY')}</span>
                        <span> - </span>
                        <span>{typeof startingDate === "string" ? startingDate : moment(startingDate).format('DD/MM/YYYY')}</span>
                    </h2>
                </header>
                <section className="reports-page__reports__general-data">
                    <div className="reports-page__reports__general-data--section1">
                        <span>
                            <p>סה”כ מתוכנן:</p>
                            <p>{reportsPageData.total_planned ? reportsPageData.total_planned.toLocaleString() : 0}</p>

                        </span>
                    </div>
                    <div className="reports-page__reports__general-data--section2">
                        <span>
                            <p>יצא:</p>
                            <p>{total_actual ? total_actual.toLocaleString() : 0}</p>
                        </span>
                    </div>
                </section>

                <div className="reports-page__reports__main-data__header">
                    <p onClick={() => this.sortDate("customer_name")}> שם לקוח {sorted_tab === "client_name" ? <img className="sort__icon" src={sort_type_client ? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p>
                    {/* <p onClick={()=> this.sortDate("departments_for_mps")}>מנהל פרויקט {sorted_tab === "departments_for_mps" ?  <img className="sort__icon" src={ sort_type_departments? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p> */}
                    <p onClick={() => this.sortDate("process")}>שלב {sorted_tab === "process" ? <img className="sort__icon" src={sort_type_process ? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p>
                    <p onClick={() => this.sortDate("planned")}>מתוכנן {sorted_tab === "planned" ? <img className="sort__icon" src={planned_value ? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p>
                    <p className='checkboxTittle'>לחיוב</p>
                    <p className='checkboxTittle'>חשבונית</p>
                    <p className='checkboxTittle'>קבלה</p>
                    <p onClick={() => this.sortDate("actual")}>יצא {sorted_tab === "actual" ? <img className="sort__icon" src={actual_value ? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p>
                    {/* <p onClick={()=> this.sortDate("is_done_value")}>הוקדם {sorted_tab === "is_done_value" ?  <img className="sort__icon" src={is_done_value? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p>
                    <p onClick={()=> this.sortDate("is_delayed_value")}>נדחה {sorted_tab === "is_delayed_value" ?  <img className="sort__icon" src={is_delayed_value? sort_icon_up : sort_icon} alt="sort icon"></img> : null}</p> */}
                </div>

                {isGenerated ? <section className="reports-page__reports__main-data">

                    {data_array && data_array.length > 0 ?
                        data_array.map((item, idx) => {
                            return <ReportRow
                                key={item.stage_id + item.order_id}
                                updateDataForCsv={this.updateDataForCsv}
                                idx={idx}
                                item={item}
                                isViewOnlyAccess={canCheckUnCheck}
                            />
                        }) : null

                    }
                </section> : <Loader />}
            </div>
        )
    }
}

function ReportCheckboxForPaymentIssued({ checkboxValue, order_id, stage_id, isViewOnlyAccess }) {
    const paymentInvoice = useSelector((store) => store.updateStagesInFinancialReport.updateStageInvoice)
    const [isIssued, setIsIssued] = useState(checkboxValue ? true : false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (paymentInvoice && paymentInvoice.order_id === order_id && paymentInvoice.stage_id === stage_id) {
            setIsIssued(paymentInvoice.invoice_issued)
        }
    }, [paymentInvoice])
    const changeValue = () => {
        dispatch(updateInvoiceOrder({ order_id, stage_id, isIssued: !isIssued }))
    }
    return <input type="checkbox" checked={isIssued} onChange={changeValue} disabled={isViewOnlyAccess} />
}

function ReportCheckboxForPaymentReceived({ checkboxValue, order_id, stage_id, isViewOnlyAccess }) {
    const paymentReceived = useSelector((store) => store.updateStagesInFinancialReport.updatePaymentReceived)
    const [isReceived, setIsReceived] = useState(checkboxValue ? true : false)
    const dispatch = useDispatch()
    useEffect(() => {
        if (paymentReceived && paymentReceived.order_id === order_id && paymentReceived.stage_id === stage_id) {
            setIsReceived(prevIsReceived => !prevIsReceived)
        }
    }, [paymentReceived])

    const changeValue = () => {
        dispatch(updateIsPaymentReceivedOrder({ order_id, stage_id, isReceived: !isReceived }))
    }
    return <input type="checkbox" checked={isReceived} onChange={changeValue} disabled={isViewOnlyAccess} />
}

function ReportRow({ item, idx, updateDataForCsv, isViewOnlyAccess }) {
    const paymentInvoice = useSelector((store) => store.updateStagesInFinancialReport.updateStageInvoice)
    const paymentReceived = useSelector((store) => store.updateStagesInFinancialReport.updatePaymentReceived)

    const [actual, setActual] = useState(item.actual)

    useEffect(() => {
        if (paymentInvoice && paymentInvoice.order_id === item.order_id && paymentInvoice.stage_id === item.stage_id && paymentInvoice.invoice_issued) {
            setActual(paymentInvoice.value)
            updateDataForCsv(idx, item, { invoice_issued: true, actual: paymentInvoice.value })
        } else if (paymentInvoice && paymentInvoice.order_id === item.order_id && paymentInvoice.stage_id === item.stage_id && !paymentInvoice.invoice_issued) {
            setActual(0)
            updateDataForCsv(idx, item, { invoice_issued: paymentInvoice.invoice_issued, actual: 0 })
        }

        if (paymentReceived && paymentReceived.order_id === item.order_id && paymentReceived.stage_id === item.stage_id && paymentReceived.payment_received) {
            updateDataForCsv(idx, item, { payment_received: paymentReceived.payment_received })
        } else if (paymentReceived && paymentReceived.order_id === item.order_id && paymentReceived.stage_id === item.stage_id && !paymentReceived.payment_received) {
            updateDataForCsv(idx, item, { payment_received: paymentReceived.payment_received })
        }
    }, [paymentInvoice, paymentReceived])

    return <div key={item.stage_id}
        className={item.isDelayed ? "reports-page__reports__main-data__item reports-page__reports__main-data__item--delayed" : "reports-page__reports__main-data__item"}>
        <p>{item.customer_name ? item.customer_name : ''}</p>
        <p>{item.process ? item.process : ''}</p>
        <p>{item.planned ? item.planned.toLocaleString() : 0}</p>
        <input type="checkbox" checked={item.billable} readOnly />
        <ReportCheckboxForPaymentIssued
            checkboxValue={item.invoice_issued}
            order_id={item.order_id}
            stage_id={item.stage_id}
            isViewOnlyAccess={isViewOnlyAccess}
        />
        <ReportCheckboxForPaymentReceived
            checkboxValue={item.payment_received}
            order_id={item.order_id}
            stage_id={item.stage_id}
            isViewOnlyAccess={isViewOnlyAccess}
        />
        <p>{actual ? actual.toLocaleString() : 0}</p>
    </div>
}


// export default ReportsPage

function mapStateToProps({ updateStagesInFinancialReport }) {
    return { updateStagesInFinancialReport };
}
export default withRouter(connect(mapStateToProps, actions)(ReportsPage))